<template>
  <section>
    <div class="box">
      <div class="box-content">
        <!-- form -->
        <validation-observer ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(editCampaign)">
            <div class="margin-top-l">
              <validation-provider
                name="nome"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  Nome da Campanha
                  <input
                    type="text"
                    v-model="newCampaign.name"
                    placeholder="Nome da campanha"
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <!-- type -->
              <div class="flex column">
                <div class="flex-1 p-8">
                  Tipo de Campanha
                </div>
                <div class="flex-1" style="padding: 8px">
                  <div
                    class="button secondary"
                    :class="{ 
                      active: newCampaign.campaign_type === 'EMAIL',
                      disabled: newCampaign.campaign_type !== 'EMAIL',
                  }"
                  >
                    E-MAIL
                  </div>
                  <div
                    class="button secondary"
                    :class="{ 
                      active: newCampaign.campaign_type === 'WHATSAPP',
                      disabled: newCampaign.campaign_type !== 'WHATSAPP'

                    }"
                    style="margin-left: 8px"
                  >
                    WHATSAPP
                  </div>
                  <div
                    class="button secondary"
                    :class="{ 
                      active: newCampaign.campaign_type === 'SMS',
                      disabled: newCampaign.campaign_type !== 'SMS'
                    }"
                    style="margin-left: 8px"
                  >
                    SMS
                  </div>
                </div>
              </div>

              <!-- contacts -->
              <div>
                <div class="flex p-8 margin-top-m">
                  Contatos para qual a campanha vai ser enviada:
                </div>
                <div class="flex margin-top-s">
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Lista
                      <select class="input" v-model="newCampaign.contact_list_id">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in listsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Tag
                      <select class="input" v-model="newCampaign.contact_tag_id">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in tagsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Exclusão de Tag
                      <select class="input" v-model="newCampaign.not_contact_tag_id">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in tagsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <!-- limite date -->
                <div class="flex column margin-top-m p-8">
                  (AFTER) Filtrar para apenas contatos que entraram na Lista ou Tag após esta data:
                  <div class="margin-top-s">
                    <date-picker
                      v-model="newCampaign.limite_date"
                      valueType="format"
                      type="datetime"
                      confirm="true"
                      confirm-text="FILTRAR CONTATOS"
                    >
                    </date-picker>
                  </div>
                </div>

                <!-- limite date -->
                <div class="flex column margin-top-m p-8">
                  (BEFORE) Filtrar para apenas contatos que entraram na Lista ou Tag antes desta data:
                  <div class="margin-top-s">
                    <date-picker
                      v-model="newCampaign.limite_date_before"
                      valueType="format"
                      type="datetime"
                      confirm="true"
                      confirm-text="FILTRAR CONTATOS"
                    >
                    </date-picker>
                  </div>
                </div>

                <div class="flex p-8 margin-top-s">
                  Quantidade de contatos que serão afetados:
                  <div class="contacts">
                    <b>{{ formatTotalContacts | number }}</b>
                  </div>
                </div>
              </div>

              <!-- schedulle -->
              <div class="flex column margin-top-m p-8">
                Agendar envio para: (Não selecionar data para disparo imediato)
                <div class="margin-top-s">
                  <date-picker
                    v-model="newCampaign.scheduling"
                    valueType="format"
                    type="datetime"
                    confirm="true"
                    confirm-text="AGENDAR ENVIO"
                  >
                  </date-picker>
                </div>
              </div>
            </div>

            <!-- message -->
            <div v-if="campaign_id" class="flex column margin-top-l p-8">
              Fluxo de mensagens:
              (Adicione cada mensagem individualmente no fluxo):
              <div class="margin-top-s box-messages w100">

                <ul>
                  <li v-if="notHaveMessage">
                    <small>
                      Adicione sua primeira mensagem para começar a rodar sua campanha.
                    </small>
                  </li>
                  <li v-for="(m, k) in messages" :key="k">
                    <div class="flex middle">
                      <div class="flex-2 flex middle">
                        <div class="flex column order">
                          <div class="button secondary" @click="upOrder(m)"><i class="fas fa-chevron-up"></i></div>
                          <div class="button secondary margin-top-s" @click="downOrder(m)"><i class="fas fa-chevron-down"></i></div>
                        </div>
                        <div style="margin-left: 16px">
                          <div v-if="m.message_type !== 'AWAIT'">
                            ({{ m.order | number }}) {{ m.name }} <span class="tag">{{ m.message_type }}</span>
                          </div>
                          <div v-else>
                            ({{ m.order | number }}) {{ m.description }} <span class="tag">{{ m.message_type }}</span>
                          </div>
                        </div>
                        <!-- ({{ m.order }}) {{ m.name }} <span class="tag">{{ m.message_type }}</span> -->
                      </div>
                      <div class="flex-1 flex end">
                        <div class="button secondary" @click="showModalEditMessage(m)">
                          <i class="fas fa-edit"></i>
                        </div>
                        <div
                            class="button secondary"
                            @click="openModalDuplicate(m.id)"
                          >
                            <i class="fas fa-copy"></i>
                        </div>
                        <div class="button secondary" @click="showDeleteMessage(m.id)">
                          <i class="fas fa-trash"></i>
                        </div>
                      </div>
                    </div>
                  </li>
                  <div class="actions margin-top-l">
                    <div class="button secondary" @click="showModalNewMessage()">
                      Adicionar nova mensagem
                    </div>
                  </div>
                </ul>

                <!-- <textarea
                  v-model="newCampaign.message"
                  wrap="off"
                  cols="155"
                  rows="10"
                ></textarea> -->
              </div>
            </div>


            <div class="margin-top-l actions">
              <router-link :to="{ name: 'Campaign' }">
                <button class="button secondary">
                  Voltar
                </button>
              </router-link>

              <button class="button primary" type="submit">
                Salvar Campanha
              </button>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>

    <!-- modals -->
    <!-- new message -->
    <modal-new-message
      :show="showModalEdit"
      :message="newMessage"
      :campaign="newCampaign"
      @close="
        showModalEdit = false;
        newMessage = null;
      "
      @accept="newOrEditMessage($event)"
    ></modal-new-message>
    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar essa mensagem?"
      @cancel="
        showModalDelete = false;
        selectModalDelete = null;
      "
      @accept="deleteMessage(selectModalDelete)"
    ></modal-confirm>

    <!-- modal confirm duplicate -->
    <modal-confirm
      :show="showModalDuplicate"
      description="Você tem certeza que deseja duplicar essa mensagem?"
      @cancel="
        showModalDuplicate = false;
        duplicateMsg = null;
      "
      @accept="duplicateMessage(duplicateMsg)"
    ></modal-confirm>
  </section>
</template>

<script>

import { 
  getContacts,
} from "@/services/contact";


import {
  updateCampaign,
  getCampaign,
} from "@/services/campaign";

import {
  createMessage,
  updateMessage,
  // getMessages,
  duplicateMessage,
  removeMessage
} from "@/services/message";


import {
  getTags
} from "@/services/tag";

import {
  getLists
} from "@/services/list";

import ModalConfirm from "@/components/modal/ModalConfirm";
import ModalNewMessage from "./NewMessage";

const emptyMessage = {
  name: '',
  description: '',
  order: 1,
  message_type: 'TEXT'
}

export default {
  name: "campaign-edit",
  components: {
    ModalConfirm,
    ModalNewMessage
  },
  props: ['campaign_id'],
  data() {
    return {
      newCampaign: {
        name: "",
        campaign_type: "",
        template: "DEFAULT",
        contact_list_id: '',
        contact_tag_id: '',
        not_contact_tag_id: '',
        scheduling: null,
        limite_date: null,
        limite_date_before: null,
        status: "",
        messages: []
      },
      listsAccount: [],
      tagsAccount: [],
      templateList: [],
      totalContacts: null,
      //
      selectModalDelete: null,
      showModalDelete: false,
      //
      showModalEdit: false,
      newMessage: null,
      //
      showModalDuplicate: false,
      duplicateMsg: null,
    };
  },
  mounted() {
    this.getTags()
    this.getLists()

    if (this.campaign_id) {
      this.getCampaign()
    }

  },
  watch: {
    'newCampaign.contact_list_id' () {
      this.getContacts()
    },
    'newCampaign.contact_tag_id' () {
      this.getContacts()
    },
    'newCampaign.not_contact_tag_id' () {
      this.getContacts()
    },
    'newCampaign.limite_date' () {
      this.getContacts()
    },
    'newCampaign.limite_date_before' () {
      this.getContacts()
    },
  },
  computed: {
    formatTotalContacts() {
      if (this.totalContacts === null) {
        return " --- ";
      }

      return this.totalContacts;
    },
    notHaveMessage() {
      return this.newCampaign && this.newCampaign.messages && this.newCampaign.messages.length == 0
    },
    messages() {
      return this.newCampaign.messages
    }
  },
  methods: {
    openModalDuplicate(msgId) {
      this.showModalDuplicate = true
      this.duplicateMsg = msgId
    },
    newOrEditMessage(newMessage) {
      this.showModalEdit = false
      this.newMessage = null

      if (newMessage.id) {
        return this.updateMessage(newMessage)
      } 

      return this.createMessage(newMessage)
    },
    showModalNewMessage() {
      this.newMessage = Object.assign({}, emptyMessage)
      this.showModalEdit = true
    },
    showModalEditMessage(message) {
      this.newMessage = message
      this.showModalEdit = true
    },
    showDeleteMessage(message_id) {
      this.selectModalDelete = message_id
      this.showModalDelete = true
    },
    duplicateMessage(message_id) {
      this.showModalDuplicate = false
      this.duplicateMsg = null
      duplicateMessage(this.campaign_id, message_id) 
        .then((result) => {
          this.newCampaign.messages.push(result)
          this.$toast.success({
            title:'Sucesso',
            message:'Mensagem duplicada'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao duplicar mensagem'
          })
        })
    },
    deleteMessage(message_id) {
      removeMessage(this.campaign_id, message_id) 
        .then(() => {
          this.newCampaign.messages = this.newCampaign.messages.filter(m => m.id != message_id)
          this.$toast.success({
            title:'Sucesso',
            message:'Mensagem removida'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao remover mensagem'
          })
        })
        .finally(() => {
          this.selectModalDelete = null
          this.showModalDelete = false
        })
    },
    getCampaign() {
      getCampaign(this.campaign_id)
        .then(result => {
          this.newCampaign = result
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao buscar campanha'
          })
        })
    },
    editCampaign() {
      let params = this.newCampaign;

      updateCampaign(this.campaign_id, params)
        .then(() => {
          // TODO: Redirect to details
          this.$toast.success({
            title: "Sucesso",
            message: "Campanha editada",
          });

        })
        .catch(() => {
            this.$toast.error({
              title: "Erro",
              message: "Ocorreu algum problema",
            });
          });
    },
    upOrder(msg) {
      msg.order = msg.order - 2
      this.recalculateOrders(msg)
    },
    downOrder(msg) {
      msg.order = msg.order + 2
      this.recalculateOrders(msg)
    },
    recalculateOrders() {
      this.newCampaign.messages.sort((a, b) => a.order - b.order);

      let currentOrder = 1;
      this.newCampaign.messages.forEach((message) => {
        message.order = currentOrder++;
      });

      // Optionally update the messages on the server side after recalculating
      this.newCampaign.messages.forEach((message) => {
        this.updateMessage(message);
      });
    },
    updateMessage(newMessage) {
      updateMessage(this.campaign_id, newMessage.id, newMessage)
        .then((result) => {
          // FIXME: Adicionar ordenação de mensagens
          let auxIndex = this.newCampaign.messages.findIndex(e => e.id == newMessage.id)
          if (auxIndex != -1) {
            this.newCampaign.messages[auxIndex] = result
          }

          this.$toast.success({
            title:'Sucesso',
            message:'Mensagem editada com sucesso'
          })

          this.newCampaign.messages.sort((a, b) => a.order - b.order)

        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao editar mensagem'
          })
        })
    },
    calCulateNewOrder() {
      const orders = this.newCampaign.messages.map(m => m.order);
      const maxOrder = Math.max(0, ...orders); 
      return maxOrder + 1;
    },
    createMessage(newMessage) {
      console.log('newMessage', newMessage)
      // fix orders
      newMessage.order = this.calCulateNewOrder()
      createMessage(this.campaign_id, newMessage)
        .then((result) => {
          // FIXME: Adicionar ordenação de mensagens
          this.newCampaign.messages.push(result)

          this.$toast.success({
            title:'Sucesso',
            message:'Mensagem criada com sucesso'
          })

        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao criar mensagem'
          })
        })
    },
    getTags() {
      this.getTags = []
      getTags()
        .then((result) => {
          this.tagsAccount = result.map(r => { return { id: r.id, label: r.name } })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao buscar dados'
          })
        })
    },
    getLists() {
      getLists()
        .then((result) => {
          this.listsAccount = result.map(r => { return { id: r.id, label: r.name } })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao buscar dados'
          })
        })
    },
    getContacts() {
      let params = {
        page: 1,
        offset: 1,
        tag: this.newCampaign.contact_tag_id,
        not_tag: this.newCampaign.not_contact_tag_id,
        list: this.newCampaign.contact_list_id,
        limite_date: this.newCampaign.limite_date,
        limite_date_before: this.newCampaign.limite_date_before,
      };
      getContacts(params)
        .then((result) => {
          this.totalContacts = result.total
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar total de contatos",
          });
        })
    },

  },
};
</script>

<style lang="scss" scoped>
.contacts {
  padding-left: 8px;
}
.p-8 {
  padding: 0px 8px;
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 1030px;
  min-width: 1030px;
  min-height: 200px;
  max-height: 200px;
}

.active {
  background: var(--primary) !important;
  color: #fff !important;
}

.disabled {
  background: #c2c2c2 !important;
  color: #000 !important;
  border: 0px !important;
  cursor: auto !important;
}


.actions {
  padding: 0px 8px;
  * {
    margin-right: 8px;
  }
}
.box-messages {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 16px 8px;
  ul {
    list-style: none;
    li {
      padding: 8px 16px;
      border-bottom: 1px solid #ccc;
      .tag {
        background: #c2c2c2;
        padding: 4px 6px;
        border-radius: 5px;
        font-size: 11px;
        font-weight: 800;
        margin-left: 8px;
      }
      .button {
        margin-left: 4px;
      }
    }
  }
}
</style>

<style lang="scss">
.mx-datepicker {
  .mx-input-wrapper {
    .mx-input {
      height: 50px;
    }
  }
  // fix icon
  svg {
    margin-top: 10px;
  }
}

.order {
  > .button.secondary {
    padding: 3px 8px;
  }
}
</style>
